import {combineReducers} from 'redux';
import {configureStore} from '@reduxjs/toolkit';

import productDataReducer from './slices/productDataSlice';
import featureModelReducer from './slices/featureModelSlice';
import sessionReducer from './slices/sessionSlice';
import statusReducer from './slices/statusSlice';
import priceReducer from './slices/priceSlice';
import shortArticleNumberReducer from './slices/shortArticleNumberSlice';
import shortNumberReducer from './slices/shortNumberSlice';
import decisionsReducer from './slices/decisionsSlice';
import downloadReducer from './slices/downloadSlice';
import configurationReducer from './slices/configurationSlice';
import lightProfileReducer from './slices/lightProfileSlice';
import userReducer from './slices/userSlice';
import solarReducer from './solar/solarSlice';
import specsheetReducer from './slices/specsheetSlice';

import {featureModelMiddleware} from './middleware/featuremodelMiddleware';
import {sectionConfigMiddleware} from './middleware/sectionConfigMiddleware';
import {rejectedDecisionsMiddleware} from './middleware/rejectedDecisionsMiddleware';
import {sessionMiddleware} from './middleware/sessionMiddleware';
import {priceMiddleware} from './middleware/priceMiddleware';
import {shortArticleNumberMiddleware} from './middleware/shortArticleNumberMiddleware';
import {explainMiddleware} from './middleware/explainMiddleware';
import {llmfMiddleware} from './middleware/llmfMiddleware';
import {dataStorageMiddleware} from './middleware/dataStorageMiddleware';
import {augmentProductDataMiddleware} from './middleware/augmentProductDataMiddleware';
import {highlightMiddleware} from './middleware/highlightMiddleware';
import {reluxMiddleware} from './middleware/reluxMiddleware';
import {modeMiddleware} from './middleware/modeMiddleware';
import {lightProfileMiddleware} from './middleware/lightProfileMiddleware';
import {productDataMiddleware} from './middleware/productDataMiddleware';
import {solarMiddleware} from './solar/solarMiddleware';
import {kirbySpecsheetMiddleware} from './middleware/kirbySpecsheetMiddleware';


const store = configureStore({

	reducer: combineReducers({
		configuration: configurationReducer,
		productData: productDataReducer,
		featureModel: featureModelReducer,
		session: sessionReducer,
		status: statusReducer,
		price: priceReducer,
		shortArticleNumber: shortArticleNumberReducer,
		shortNumber: shortNumberReducer,
		decisions: decisionsReducer,
		download: downloadReducer,
		lightProfile: lightProfileReducer,
		userProfile: userReducer,
		solar: solarReducer,
		specsheet: specsheetReducer
	}),
	devTools: process.env.NODE_ENV !== 'production',

	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: {
			// Ignore these action types
			// Todo: do not put dataManager in store
			ignoredActionPaths: ['payload.dataManager'],
			ignoredPaths: ['status.dataManager']
		},
	}).concat(
		sessionMiddleware,
		featureModelMiddleware,
		sectionConfigMiddleware,
		rejectedDecisionsMiddleware,
		dataStorageMiddleware,
		priceMiddleware,
		llmfMiddleware,
		augmentProductDataMiddleware,
		explainMiddleware,
		highlightMiddleware,
		modeMiddleware,
		shortArticleNumberMiddleware,
		reluxMiddleware,
		lightProfileMiddleware,
		productDataMiddleware,
		solarMiddleware,
		kirbySpecsheetMiddleware
	)

});


export default store;
